import { useToastStore } from "@/stores/toastStore";
import { config } from "@/types/config";
import i18n from "@/utils/i18n";
import { defineStore } from "pinia";

export const useConfigStore = defineStore("configStore", {
	state: () => ({
		toast: null as any,
		initialized: false as boolean,
		config: null as config | null
	}),
	actions: {
		async init() {
			if (this.initialized) {
				return;
			}
			this.toast = useToastStore();
			try {
				const data = await (await fetch("/config.json")).json();
				this.config = data;
				this.initialized = true;
			} catch (e: any) {
				this.toast.toast({
					type: "error",
					message: i18n.global.t("storeConfigToasts.errorMsg"),
					title: i18n.global.t("storeConfigToasts.errorTitle"),
					dismissable: false
				});
			}
		}
	}
});
